import { useState } from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Card,
  CardHeader,
  CardBody,
  useColorModeValue,
} from "@chakra-ui/react";
import BreadCrumbMaker from "../../components/BreadCrumbMaker";

const CustomerPolicies = () => {
  const bgColor = useColorModeValue("white", "gray.800");

  const breadcrumbItems = [
    { title: "Customer Management", link: "/history" },
    { title: "Customer Policies", link: "/customer-policies" },
  ];

  return (
    <Container maxW="container.xl" py={6}>
      <BreadCrumbMaker items={breadcrumbItems} />
      <Heading size="lg" mb={6}>
        Customer Policies
      </Heading>

      <VStack spacing={4} align="stretch">
        <Card bg={bgColor}>
          <CardHeader>
            <Heading size="md">Policies</Heading>
          </CardHeader>
          <CardBody>
            <Text color="gray.500">
              Customer policies will be displayed here. This section is under
              development.
            </Text>
          </CardBody>
        </Card>
      </VStack>
    </Container>
  );
};

export default CustomerPolicies;
